import React from 'react';

const Logo = ({ className = "", size = 120, inverted = false }) => {
  return (
    <img
      src="/logo.png"
      alt="Vejles Juletræsfest Logo"
      width={size}
      height={size}
      className={className}
      style={{ 
        objectFit: 'contain',
        filter: inverted ? 'brightness(0) invert(1)' : 'none'
      }}
    />
  );
};

export default Logo;
